import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { API_BASE_URL } from './config';

// ── Global session-expiry guard ──────────────────────────────────────────────
// Any 401 from the Margix API means the stored JWT has expired (or was revoked).
// Clear the session and bounce to the login screen so the user re-authenticates,
// instead of leaving them on the dashboard staring at a cryptic "Invalid or
// expired token" inline error (Koen kept hitting this on "Pull from Chrona").
// The login call is excluded (a wrong-password 401 there must not redirect) and
// we only act when not already on the login route ("/").
const _origFetch = window.fetch.bind(window);
window.fetch = async (...args) => {
  const res = await _origFetch(...args);
  try {
    const input = args[0];
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const isApi = url.indexOf(API_BASE_URL) !== -1;
    const isLogin = url.indexOf('/api/login') !== -1;
    if (res.status === 401 && isApi && !isLogin && window.location.pathname !== '/') {
      localStorage.removeItem('token');
      localStorage.removeItem('chrona_token');
      window.location.assign('/?expired=1');
    }
  } catch (_) {
    // Never let the guard turn a normal response into an error.
  }
  return res;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
